const Sidebar = ({ children }) => {

    const animateSidebar = {
        initial: { opacity: 0, x: 500 },
        animate: { opacity: 1, x: 0 },
        exit: {}
    }

    return ( 
        <aside 
            className="z-front overflow-hidden hidden lg:block"
            variants={animateSidebar}
            initial='initial'
            animate='animate'
            exit='exit'
        >
            {children}
        </aside>
     );
}
 
export default Sidebar;